import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {isEmpty} from 'lodash';
import {Button} from 'ui-library';
import i18n from 'i18n';

import {fetchBrandUsers, transferOwnership} from 'redux/modules/brands';

import {getBrandUsers} from 'modules/shared/selectors';

import Dialog from 'modules/legacy/js/components/dialog';
import {LoadingState} from 'modules/shared/components';
import SelectableChip from 'modules/shared/components/SelectableChip/SelectableChip';
import AdvertiserChip from 'modules/shared/components/AdvertiserChip/AdvertiserChip';

import {
  hideModal,
  resetRequest,
  sendRequest,
  showAlert
} from 'redux/modules/app';

const REQUEST_ID = 'transferBrandOwnership';

function mapStateToProps(state, {brandId}) {
  const {entities, shared, app} = state;
  const {requests} = app;
  const {user} = shared;
  const {Account: brands} = entities;
  const request = requests[REQUEST_ID] || {};
  const brand = brands[brandId];
  const brandUsers = getBrandUsers(state, brandId)
    .filter(u => u.userId !== user._id && u.status === 'active');

  return {request, brand, user, brandUsers};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchBrandUsers,
    transferOwnership,
    hideModal,
    resetRequest,
    sendRequest,
    showAlert
  }, dispatch);
}

const TransferDialog = createClass({
  propTypes: {
    brandId: PropTypes.string.isRequired,
    brand: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    brandUsers: PropTypes.array.isRequired,
    request: PropTypes.object,
    fetchBrandUsers: PropTypes.func.isRequired,
    transferOwnership: PropTypes.func.isRequired,
    resetRequest: PropTypes.func.isRequired,
    sendRequest: PropTypes.func.isRequired,
    showAlert: PropTypes.func.isRequired,
    hideModal: PropTypes.func.isRequired
  },

  getInitialState() {
    return {newOwnerId: null};
  },

  componentWillMount() {
    const {brandUsers, fetchBrandUsers, brandId, resetRequest} = this.props;

    resetRequest(REQUEST_ID);
    if (isEmpty(brandUsers)) fetchBrandUsers({brandId});
  },

  componentWillReceiveProps(props) {
    const {request} = props;

    if (request.status === 'success') this.onSuccess();
    if (request.status === 'fail') this.onFail(request);
  },

  onSuccess() {
    const {showAlert, hideModal, changePage} = this.props;

    hideModal();
    showAlert({
      type: 'success',
      message: i18n.get('ADV_BRAND_OWNERSHIP_TRANSFER_DIALOG_SUCCESS_MESSAGE')
    });
  },

  onFail(request) {
    const {showAlert} = this.props;
    showAlert({
      type: 'error',
      message: request.response.message
    });
  },

  buildUserOptions() {
    const {brandUsers} = this.props;
    const {newOwnerId} = this.state;

    return brandUsers.map((u) => {
      return (
        <div className='col-xs-4 padding-Hx'>
          <SelectableChip
            isSelected={newOwnerId === u.userId}
            onClick={() => this.setState({newOwnerId: u.userId})}
          >
            <AdvertiserChip advertiser={u} />
          </SelectableChip>
        </div>
      );
    });
  },

  transfer() {
    const {brand, transferOwnership} = this.props;
    const {newOwnerId} = this.state;

    transferOwnership({brand, newOwnerId});
  },

  getContent() {
    const {hideModal, brandUsers, brand, request} = this.props;
    const {newOwnerId} = this.state;
    const isLoading = request.status === 'loading';

    if (isLoading) return <LoadingState />;
    if (!isLoading && isEmpty(brandUsers)) {
      return (
        <h3 className='padding-2x text-center'>
          {i18n.get('ADV_BRAND_OWNERSHIP_TRANSFER_DIALOG_EMPTY_SATE')}
        </h3>
      );
    }
    return (
      <div className='padding-2x'>
        <h5 className='vf-font-normal'>
          {i18n.getHTML('ADV_BRAND_OWNERSHIP_TRANSFER_DIALOG_BODY', {brandName: brand.name})}

          <p className='vf-font-bold margin-top-2x'>
            {i18n.get('ADV_BRAND_OWNERSHIP_TRANSFER_DIALOG_CHOOSE_TEXT')}
          </p>

        </h5>

        <div className='margin-top-1x vf-scrolly' style={{height: '38rem'}}>
          <div className='vf-row no-margin'>{this.buildUserOptions()}</div>
        </div>

        <div className='flex end-xs width100 margin-top-2x'>
          <Button className='margin-right-Hx' onClick={hideModal}>
            {i18n.get('CANCEL')}
          </Button>

          <Button color='primary' disabled={!newOwnerId || isLoading} onClick={this.transfer}>
            {isLoading ? i18n.get('ADV_BRAND_OWNERSHIP_TRANSFER_DIALOG_TRANSFER_BUTTON_LOADING') : i18n.get('ADV_BRAND_OWNERSHIP_TRANSFER_DIALOG_TRANSFER_BUTTON')}
          </Button>
        </div>
      </div>
    );
  },

  render() {
    const {hideModal} = this.props;
    return (
      <Dialog
        dismissable={false}
        header={i18n.get('ADV_BRAND_OWNERSHIP_TRANSFER_DIALOG_TITLE')}
        content={this.getContent()}
        onClose={hideModal}
      />
    );
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(TransferDialog);
